// @flow
import React from 'react';

import { SelectField } from '../../../formik-utils/FormFields';
import { StyledSegmentWithBorderColor } from '../../../common-utils/styledComponents';

export const ConnectorMetadataDropdownContainer = ({
  fieldName,
  fieldDisplayName,
  dropdownOptions,
  onChange = () => {},
}) => (
  <StyledSegmentWithBorderColor>
    <SelectField
      disabled={false}
      fieldDisplayName={fieldDisplayName}
      fieldName={fieldName}
      fluid={true}
      onChange={onChange}
      options={dropdownOptions}
      search={false}
    />
  </StyledSegmentWithBorderColor>
);
